webpackJsonp([68],{

/***/ 1154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OccupationTable_vue__ = __webpack_require__(2791);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13be24b4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OccupationTable_vue__ = __webpack_require__(4594);
function injectStyle (ssrContext) {
  __webpack_require__(4588)
  __webpack_require__(4590)
  this["$style"] = __webpack_require__(4592)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-13be24b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OccupationTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13be24b4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OccupationTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OccupationUsersTable_vue__ = __webpack_require__(2795);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bd30cb8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OccupationUsersTable_vue__ = __webpack_require__(4614);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OccupationUsersTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bd30cb8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OccupationUsersTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * ElementUI 日期选择组件的参数
 * @Author: anker.wang
 * @Date: 2018-01-08 11:27:07
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-01-08 11:28:27
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dateTimePickerOptions: {
        shortcuts: [{
          text: '一周后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '明天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '今天',
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      dateTimePickerRangeOptions: {
        shortcuts: [{
          text: '最近1周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近6个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近2年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 730);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1095);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  }
});

/***/ }),

/***/ 1348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = trimParams;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeEmptyParams;
/* unused harmony export setParams */
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* unused harmony export conveSomeDataType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSearchParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query, to.params);
        // 设置搜索参数。 当仅 params 更新时, 需要全部重置 search 数据
        vm.setSearchParams(_.merge(vm.$options.data.call(vm).search, queryParams));
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query, to.params);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     * @param {*} params
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$route.params;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      if (params.hasOwnProperty('')) {
        delete params[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, query, params), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSearchParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSearchParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      if (params[key] && params[key].constructor === Object) {
        setParams(params[key], newParams[key]);
      } else {
        Vue.set(params, key, newParams[key]);
      }
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1512:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xlsx__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_xlsx__);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      archivedFields: [{
        prop: 'taskid',
        label: '任务ID',
        formatter: function formatter(row) {
          return 'TSK' + row.taskid;
        }
      }, {
        prop: 'title',
        label: '任务标题'
      }, {
        prop: 'type',
        label: '任务类型',
        formatter: function formatter(row) {
          return _this.getOptionLabel('allType', row.type);
        }
      }, {
        prop: 'assignnum',
        label: '完成人'
      }, {
        prop: 'salary',
        label: '赏金',
        formatter: function formatter(row) {
          return filter.hasPermission(250) ? row.salary : '*';
        }
      }, {
        prop: 'starttime_endtime',
        label: '任务时间',
        formatter: function formatter(row) {
          return row.starttime + '\n' + row.endtime;
        },
        width: '160px'
      }, {
        prop: 'city',
        label: '城市',
        formatter: function formatter(row) {
          return '' + row.provincename + row.cityname + row.areaname;
        }
      }, {
        prop: 'marketname',
        label: '门店名称'
      }, {
        prop: 'status',
        label: '任务状态',
        formatter: function formatter(row) {
          return _this.getOptionLabel('status', row.status);
        }
      }, {
        prop: 'adminname',
        label: '任务发布人'
      }, {
        prop: 'customerid',
        label: '所属客户',
        formatter: function formatter(row) {
          return row.customerid ? row.customer_name + '/' + row.customer_number : '平台';
        }
      }, {
        prop: 'publishtime',
        label: '发布时间',
        formatter: function formatter(row) {
          return '' + row.publishtime;
        },
        width: '160px'
      }],
      orderArchivedFields: [{
        prop: 'orderid',
        label: '工单ID',
        formatter: function formatter(row) {
          return 'ORD' + row.orderid;
        }
      }, {
        prop: 'title',
        label: '任务标题'
      }, {
        prop: 'type',
        label: '任务类型',
        formatter: function formatter(row) {
          return _this.getOptionLabel('allType', row.type);
        }
      }, {
        prop: 'userid',
        label: '完成人'
      }, {
        prop: 'salary',
        label: '赏金',
        formatter: function formatter(row) {
          return filter.hasPermission(250) ? row.salary : '*';
        }
      }, {
        prop: 'starttime_endtime',
        label: '任务时间',
        formatter: function formatter(row) {
          return row.starttime + '\n' + row.endtime;
        },
        width: '160px'
      }, {
        prop: 'city',
        label: '城市',
        formatter: function formatter(row) {
          return '' + row.provincename + row.cityname + row.areaname;
        }
      }, {
        prop: 'marketname',
        label: '门店名称'
      }, {
        prop: 'status',
        label: '任务状态',
        formatter: function formatter(row) {
          return _this.getOptionLabel('status', row.status);
        }
      }, {
        prop: 'adminname',
        label: '任务发布人'
      }, {
        prop: 'customerid',
        label: '所属客户',
        formatter: function formatter(row) {
          return row.customerid ? row.customer_name + '/' + row.customer_number : '平台';
        }
      }, {
        prop: 'review',
        label: '审核次数'
      }, {
        prop: 'publishtime',
        label: '发布/更新时间',
        formatter: function formatter(row) {
          return row.publishtime + '\n' + (row.lastupdatetime || '');
        },
        width: '160px'
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.order.options;
    }
  })),
  methods: {
    onUploadFile: function onUploadFile(file, taskType) {
      var _this2 = this;

      var fileType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 6;

      var isLt10M = file.raw.size / 1024 / 1024 < 10;
      if (taskType === 231) {
        fileType = 8;
      }

      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!');
        this.$refs.upload.clearFiles();
        return false;
      }

      var formData = new FormData();
      formData.append('file', file.raw);
      formData.append('collection_type', 2); // 集合类型为2
      formData.append('type', taskType);
      formData.append('file_type', fileType);

      request.common('createTaskBatch', formData).then(function (_ref) {
        var data = _ref.data;

        _this2.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this2.onSearch();
      });
    },
    createTaskBatch: function createTaskBatch(file) {
      var _this3 = this;

      var formData = new FormData();
      formData.append('file', file.raw);

      request.common('createTaskBatchJob', formData).then(function (_ref2) {
        var data = _ref2.data;

        _this3.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this3.onSearch();
      });
    },
    createTaskBatchWithTemplate: function createTaskBatchWithTemplate(file) {
      var _this4 = this;

      var formData = new FormData();
      formData.append('file', file.raw);

      request.common('createTaskWithTemplateBatchJob', formData).then(function (_ref3) {
        var data = _ref3.data;

        _this4.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this4.onSearch();
      });
    },
    uploadAuditReferenceBatch: function uploadAuditReferenceBatch(file) {
      var _this5 = this;

      var isLt10M = file.raw.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!');
        return false;
      }
      var formData = new FormData();
      formData.append('file', file.raw);

      request.common('importTaskAuditReferenceBatchJob', formData).then(function () {
        _this5.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this5.onSearch();
      });
    },
    editTaskBatch: function editTaskBatch(file) {
      var _this6 = this;

      var formData = new FormData();
      formData.append('file', file.raw);

      request.common('editTaskBatchJob', formData).then(function (_ref4) {
        var data = _ref4.data;

        _this6.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this6.onSearch();
      });
    },
    deleteTaskBatch: function deleteTaskBatch(file) {
      var _this7 = this;

      var formData = new FormData();
      formData.append('file', file.raw);

      request.common('deleteTaskBatchJob', formData).then(function (_ref5) {
        var data = _ref5.data;

        _this7.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this7.onSearch();
      });
    },
    reactivateTaskBatch: function reactivateTaskBatch(file) {
      var _this8 = this;

      var formData = new FormData();
      formData.append('file', file.raw);

      request.common('reactivateTaskBatchJob', formData).then(function (_ref6) {
        var data = _ref6.data;

        _this8.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this8.onSearch();
      });
    },

    // 解析上传的excel文件 看一下是否超过MaxRowLimit
    parseExcelFile: function parseExcelFile(file) {
      var maxRowLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20000;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var isSatisfy = true;
        var errorMessage = '';
        // 先校验一下文件的大小
        var isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
          isSatisfy = false;
          errorMessage = '上传表格行数超过10M，可能引起性能故障并导致更新失败。请与产品联系后上传，产品开发将关注后续更新情况。';
          return resolve({ isSatisfy: isSatisfy, errorMessage: errorMessage });
        }
        var reader = new FileReader();
        reader.onload = function (e) {
          try {
            var data = new Uint8Array(e.target.result);
            var workbook = __WEBPACK_IMPORTED_MODULE_4_xlsx___default.a.read(data, { type: 'array' });

            var firstSheetName = workbook.SheetNames[0];
            var worksheet = workbook.Sheets[firstSheetName];

            var jsonData = __WEBPACK_IMPORTED_MODULE_4_xlsx___default.a.utils.sheet_to_json(worksheet, { header: 1 });
            // 计算数据条数，减去第一行标题
            var rowCount = jsonData.length - 1;
            // 超过限定的长度
            if (rowCount > maxRowLimit) {
              isSatisfy = false;
              errorMessage = '\u4E0A\u4F20\u8868\u683C\u884C\u6570\u8D85\u8FC7' + maxRowLimit + '\u6761\uFF0C\u53EF\u80FD\u5F15\u8D77\u6027\u80FD\u6545\u969C\u5E76\u5BFC\u81F4\u66F4\u65B0\u5931\u8D25\u3002\u8BF7\u4E0E\u4EA7\u54C1\u8054\u7CFB\u540E\u4E0A\u4F20\uFF0C\u4EA7\u54C1\u5F00\u53D1\u5C06\u5173\u6CE8\u540E\u7EED\u66F4\u65B0\u60C5\u51B5\u3002';
            } else {
              isSatisfy = true;
            }
            return resolve({ isSatisfy: isSatisfy, errorMessage: errorMessage });
          } catch (error) {
            reject(Error('\u6587\u4EF6\u89E3\u6790\u5931\u8D25: ' + error.message));
            throw new Error(error);
          }
        };
        reader.onerror = function () {
          reject(Error('文件读取失败'));
        };
        reader.readAsArrayBuffer(file);
      });
    },

    // 上传任务可执行时间段 需要先校验一下他的行数
    taskAvailableTimeBatch: function taskAvailableTimeBatch(file) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref7, isSatisfy, errorMessage;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this9.$store.commit('OPEN_LOADING');
                _context.next = 4;
                return _this9.parseExcelFile(file.raw, 20000);

              case 4:
                _ref7 = _context.sent;
                isSatisfy = _ref7.isSatisfy;
                errorMessage = _ref7.errorMessage;

                _this9.$store.commit('CLOSE_LOADING');
                // 超过限制 提示

                if (isSatisfy) {
                  _context.next = 22;
                  break;
                }

                _context.prev = 9;
                _context.next = 12;
                return _this9.$confirm(errorMessage, '警告', {
                  type: 'warning',
                  confirmButtonText: '已联系，继续操作',
                  cancelButtonText: '取消'
                });

              case 12:
                _context.next = 14;
                return _this9.uploadTaskAvailableTimeBatch(file);

              case 14:
                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](9);

                _this9.$message.info('已取消上传');
                throw new Error(_context.t0);

              case 20:
                _context.next = 24;
                break;

              case 22:
                _context.next = 24;
                return _this9.uploadTaskAvailableTimeBatch(file);

              case 24:
                _context.next = 30;
                break;

              case 26:
                _context.prev = 26;
                _context.t1 = _context['catch'](0);

                _this9.$message.error(_context.t1);
                throw new Error(_context.t1);

              case 30:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this9, [[0, 26], [9, 16]]);
      }))();
    },

    // 上传excel
    uploadTaskAvailableTimeBatch: function uploadTaskAvailableTimeBatch(file) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var formData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                formData = new FormData();

                formData.append('file', file.raw);
                _context2.next = 4;
                return request.common('taskAvailableTimeBatchJob', formData);

              case 4:
                _this10.$message({
                  showClose: true,
                  message: '上传成功',
                  type: 'success'
                });
                _this10.onSearch();

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this10);
      }))();
    },

    // 任务可执行时间端 点击
    confirmTaskAvailableTimeBatch: function confirmTaskAvailableTimeBatch(e) {
      e.stopPropagation();
      this.$refs['upload'].$refs['upload-inner'].handleClick();
    },
    onPublishTask: function onPublishTask(task) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var totalSalary;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!moment(task.taskendtime).isBefore(moment())) {
                  _context3.next = 4;
                  break;
                }

                _this11.$message.error('任务结束时间必须大于当前时间');
                _context3.next = 15;
                break;

              case 4:
                totalSalary = _.round(task.hirenum * task.salary, 2);
                _context3.next = 7;
                return _this11.$prompt('\u4EFB\u52A1[' + task.taskid + ']\u7684\u62A5\u916C' + task.salary + '\u5143\uFF0C\u9700\u8981' + task.hirenum + '\u4EBA\uFF0C\u8BF7\u8F93\u5165\u603B\u91D1\u989D\uFF1A' + totalSalary, '提示', {
                  confirmButtonText: '发布',
                  cancelButtonText: '取消',
                  inputPattern: new RegExp('^' + totalSalary + '$'),
                  inputErrorMessage: '金额输入错误',
                  inputPlaceholder: totalSalary,
                  closeOnClickModal: false
                });

              case 7:
                _context3.next = 9;
                return request.alert('taskPublish', { taskid: task.taskid });

              case 9:
                _this11.$store.commit('OPEN_LOADING');
                _context3.next = 12;
                return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
                  setTimeout(function () {
                    resolve();
                    _this11.$store.commit('CLOSE_LOADING');
                  }, 2000);
                });

              case 12:
                _context3.next = 14;
                return _this11.onRefresh();

              case 14:

                _this11.$message({
                  showClose: true,
                  message: '\u4EFB\u52A1[' + task.taskid + ']\u53D1\u5E03\u6210\u529F',
                  type: 'success'
                });

              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this11);
      }))();
    },
    getOptionLabel: function getOptionLabel(optType, val) {
      var type = this.options[optType].find(function (one) {
        return one.value === val;
      });
      return type ? type.label : '';
    },
    countDown: function countDown(date) {
      var futureTs = (Date.parse(date) + '').substr(0, 10);
      var currentTs = (new Date().getTime() + '').substr(0, 10);
      var interval = futureTs - currentTs;

      if (interval < 0) {
        return '';
      }

      return filter.formatTimerHumanize(interval);
    }
  }
});

/***/ }),

/***/ 2791:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_mixins_dateTimePicker__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mixins_table_v3__ = __webpack_require__(1348);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__core_mixins_table_v3__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__core_mixins_dateTimePicker__["a" /* default */]],
  data: function data() {
    return {};
  },

  computed: Vuex.mapState({}),
  created: function created() {},

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), request.map([]), {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {
      return request.page('getOccupationTable', params);
    }
  })
});

/***/ }),

/***/ 2795:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_mixins_table_v3__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_task_task_mixins__ = __webpack_require__(1512);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__core_mixins_table_v3__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__views_task_task_mixins__["a" /* default */]],
  data: function data() {
    return {
      addUserDialog: {
        visible: false,
        userid: null
      },
      userOptions: {
        tags: []
      },
      loading: false,
      search: {
        id: null,
        keyword: null,
        occupation_id: this.$route.params.id
      },
      // 搜索字段申明
      searchFieldType: {},
      exportHeader: [{
        key: 'userid',
        text: '用户ID'
      }, {
        key: 'realname',
        text: '真实姓名'
      }, {
        key: 'provincename',
        text: '省份'
      }, {
        key: 'cityname',
        text: '城市'
      }, {
        key: 'areaname',
        text: '地区'
      }, {
        key: 'id_card_province_name',
        text: '身份证省份'
      }, {
        key: 'id_card_city_name',
        text: '身份证城市'
      }, {
        key: 'id_card_area_name',
        text: '身份证地区'
      }, {
        key: 'id_card_sex',
        text: '身份证性别'
      }, {
        key: 'id_card_age',
        text: '身份证年龄'
      }, {
        key: 'cellphone',
        text: '手机号码'
      }, {
        key: 'strstatus',
        text: '用户状态'
      }, {
        key: 'strcurrentstatus',
        text: '用户当前状态'
      }, {
        key: 'referrer',
        text: '推荐人手机'
      }, {
        key: 'registertime',
        text: '注册时间'
      }, {
        key: 'cumulative_bounty',
        text: '累计赏金'
      }, {
        key: 'balance',
        text: '账户余额'
      }, {
        key: 'salary_last_update_time',
        text: '赏金最后更新时间'
      }, {
        key: 'customername',
        text: '最后任务所属客户'
      }, {
        key: 'tag_info',
        text: '主平台标签（显示名称）'
      }, {
        key: 'clientmodel',
        text: '手机型号'
      }, {
        key: 'devicenum',
        text: '手机设备号'
      }, {
        key: 'clientversion',
        text: 'APP版本号'
      }, {
        key: 'strlevel',
        text: '用户等级'
      }, {
        key: 'str_is_super',
        text: '是否为超级零工'
      }, {
        key: 'str_super',
        text: '超级零工属性'
      }, {
        key: 'ability_group',
        text: '用户能力组'
      }, {
        key: 'work_type',
        text: '工种'
      }, {
        key: 'belongto',
        text: '厂家'
      }, {
        key: 'referrer_belongto',
        text: '厂家关联'
      }, {
        key: 'wx_account',
        text: '微信账号'
      }, {
        key: 'occupation_text',
        text: '自选职业'
      }]
    };
  },

  computed: Vuex.mapState({
    options: function options(state) {
      return state.users.options;
    },
    users: function users(state) {
      return state.login.user;
    },
    otherOptions: function otherOptions(state) {
      return state.users.userOptions;
    }
  }),
  created: function created() {
    this.$store.dispatch('getUserRelatedOptions');
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, request.map(['getOccupationTable', 'getOccupationDetail', 'getUserTable', 'getUserDetail_']), {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {
      return request.page('getOccupationUserList', params);
    },
    onExportSearch: function onExportSearch() {
      var self = this;
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: function (_request) {
          function request(_x) {
            return _request.apply(this, arguments);
          }

          request.toString = function () {
            return _request.toString();
          };

          return request;
        }(function (params) {
          return request('exportUser', params);
        }),
        requestParams: this.search,
        getResponseData: function getResponseData(data) {
          for (var m = 0; m < data.data.length; m++) {
            data.data[m].cumulative_bounty = parseFloat(data.data[m].balance) + parseFloat(data.data[m].frozenbalance) + parseFloat(data.data[m].totalwithdraw);
            console.log(data.data[m].customername);
            if (!data.data[m].customername) {
              data.data[m].customername = '';
            }

            if (data.data[m].id_card_age === false) {
              data.data[m].id_card_age = '';
            }

            if (data.data[m].id_card_sex === false) {
              data.data[m].id_card_sex = '';
            } else if (data.data[m].id_card_sex === 0) {
              data.data[m].id_card_sex = '男';
            } else if (data.data[m].id_card_sex === 1) {
              data.data[m].id_card_sex = '女';
            }

            for (var i = 0; i < self.options.status.length; i++) {
              if (parseInt(data.data[m].status) === self.options.status[i].value) {
                data.data[m].strstatus = self.options.status[i].label;
              }
            }

            for (var _i = 0; _i < self.options.currentstatus.length; _i++) {
              if (parseInt(data.data[m].currentstatus) === self.options.currentstatus[_i].value) {
                data.data[m].strcurrentstatus = self.options.currentstatus[_i].label;
              }
            }

            for (var _i2 = 0; _i2 < self.options.level.length; _i2++) {
              if (parseInt(data.data[m].level) === self.options.level[_i2].value) {
                data.data[m].strlevel = self.options.level[_i2].label;
              }
            }

            if (data.data[m].str_super_attr) {
              data.data[m].str_super = data.data[m].str_super_attr.join(',');
            }
            if (data.data[m].ability_group) {
              data.data[m].str_ability_group = data.data[m].ability_group.join(',');
            }
            data.data[m].str_is_super = data.data[m].is_super === 1 ? '是' : '不是';

            if (data.data[m].work_type && data.data[m].work_type !== '0') {
              for (var _i3 = 0; _i3 < self.otherOptions.work_type.length; _i3++) {
                if (parseInt(data.data[m].work_type) === self.otherOptions.work_type[_i3].id) {
                  data.data[m].work_type = self.otherOptions.work_type[_i3].keyword;
                }
              }
            } else {
              data.data[m].work_type = '';
            }
          }
          return data;
        }
      });
    },
    remove: function remove(userid) {
      var _this = this;

      this.$confirm('您确认要执行该操作吗？', '警告', { type: 'warning' }).then(function () {
        request.common('deleteOccupationUser', { id: _this.search.occupation_id, userid: userid }).then(function () {
          _this.$message.success('操作成功！');
          _this.onRefresh();
        });
      });
    },
    onAddUser: function onAddUser() {
      var _this2 = this;

      request.common('addOccupationUser', {
        id: this.search.occupation_id,
        userid: this.addUserDialog.userid
      }).then(function () {
        _this2.addUserDialog.visible = false;
        _this2.$message.success('操作成功！');
        _this2.onRefresh();
      });
    },
    onUploadFile: function onUploadFile(file, taskType) {
      var _this3 = this;

      var isLt10M = file.raw.size / 1024 / 1024 < 10;

      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!');
        this.$refs.upload.clearFiles();
        return false;
      }

      var formData = new FormData();
      formData.append('file', file.raw);
      formData.append('collection_type', 1); // 集合类型为1
      formData.append('type', taskType);
      formData.append('params[occupation_id]', this.search.occupation_id);

      request.common('createTaskBatch', formData).then(function (_ref) {
        var data = _ref.data;

        _this3.$confirm('请问您是否想跳转至用户批量任务页面呢？', '温馨提示', { type: 'success' }).then(function () {
          _this3.$router.push('/users/batch/table');
        });
      });
    }
  })
});

/***/ }),

/***/ 4588:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4589);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("214c2b5c", content, true, {});

/***/ }),

/***/ 4589:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"OccupationTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4590:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4591);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("b87605e4", content, true, {});

/***/ }),

/***/ 4591:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"OccupationTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4592:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4593);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("52eb5e26", content, true, {});

/***/ }),

/***/ 4593:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"OccupationTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4594:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("自选职业管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('div',{staticClass:"margin b15",staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('router-link',{attrs:{"to":'/users/occupation/create'}},[_c('el-button',{attrs:{"type":"primary","icon":"sj-icon-add","size":"small"}},[_vm._v("添加职业\n        ")])],1),_vm._v(" "),_c('router-link',{attrs:{"to":'/users/occupation-questionnaire'}},[_c('el-button',{attrs:{"type":"primary","size":"small"}},[_vm._v("推送列表\n        ")])],1)],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":""}},[_c('el-table-column',{attrs:{"prop":"id","label":"ID","min-width":"90"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"职业名称","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"adminname","label":"创建人","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"user_cnt","label":"零工数量","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created_at","label":"添加日期","width":"190"}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"260"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"button-gutter"},[_c('router-link',{attrs:{"to":("/users/occupation/" + (scope.row.id) + "/users")}},[_c('el-button',{attrs:{"size":"mini","type":"success"}},[_vm._v("查看该职业用户\n              ")])],1),_vm._v(" "),_c('router-link',{attrs:{"to":("/users/occupation/update/" + (scope.row.id))}},[_c('el-button',{attrs:{"size":"mini","type":"primary"}},[_vm._v("编辑\n              ")])],1)],1)]}}])})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 4614:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v("\n      "+_vm._s(_vm.$route.meta.title)+"\n    ")]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("用户管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"collapse":false}},[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"label-width":"96px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"用户ID","prop":"id"}},[_c('el-input',{attrs:{"placeholder":"请输入用户ID","clearable":""},model:{value:(_vm.search.userid),callback:function ($$v) {_vm.$set(_vm.search, "userid", $$v)},expression:"search.userid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"关键字","prop":"keyword"}},[_c('el-input',{attrs:{"placeholder":"请输入名称","clearable":""},model:{value:(_vm.search.keyword),callback:function ($$v) {_vm.$set(_vm.search, "keyword", $$v)},expression:"search.keyword"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit"}},[_vm._v("搜索\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"icon":"sj-icon-export"},on:{"click":function($event){return _vm.onExportSearch()}}},[_vm._v("导出\n        ")])],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('div',{staticClass:"margin b15"},[_c('el-button',{attrs:{"type":"primary","icon":"sj-icon-add","size":"small"},on:{"click":function($event){_vm.addUserDialog.visible = true}}},[_vm._v("添加用户\n      ")]),_vm._v(" "),_c('el-upload',{ref:"upload",staticStyle:{"display":"inline-block"},attrs:{"action":"","auto-upload":false,"on-change":function (query) { return _vm.onUploadFile(query, 255); },"accept":".xlsx,.xls","show-file-list":false}},[_c('el-tooltip',{attrs:{"content":"上传表格的第一列请勿出现空值，出现空值将直接结束批量任务"}},[_c('el-button',{attrs:{"icon":"sj-icon-export","type":"primary","size":"small"}},[_vm._v("批量添加用户\n          ")])],1)],1),_vm._v(" "),_c('el-upload',{ref:"upload",staticStyle:{"display":"inline-block"},attrs:{"action":"","auto-upload":false,"on-change":function (query) { return _vm.onUploadFile(query, 256); },"accept":".xlsx,.xls","show-file-list":false}},[_c('el-tooltip',{attrs:{"content":"上传表格的第一列请勿出现空值，出现空值将直接结束批量任务"}},[_c('el-button',{attrs:{"icon":"el-icon-delete","type":"danger","size":"small"}},[_vm._v("批量移除用户\n          ")])],1)],1)],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":""}},[_c('el-table-column',{attrs:{"prop":"userid","label":"用户id","width":"100px"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cellphone","label":"手机号","width":"110px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":'/users/detail/info?userid='+scope.row.userid}},[_c('span',{staticStyle:{"color":"rgb(88,157,248)"}},[_vm._v(_vm._s(scope.row.cellphone))])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"realname","label":"用户名称","width":"80px"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"所在地","width":"150px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(scope.row.provincename)+"  "+_vm._s(scope.row.cityname)+"  "+_vm._s(scope.row.areaname)+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"marketname","label":"所在卖场"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"registertime","label":"注册时间"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"用户状态"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((_vm.options.status),function(item){return (item.value === parseInt(scope.row.status))?_c('span',[_vm._v(_vm._s(item.label))]):_vm._e()})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"currentstatus","label":"用户当前状态"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((_vm.options.currentstatus),function(item){return (item.value === parseInt(scope.row.currentstatus))?_c('span',[_vm._v(_vm._s(item.label))]):_vm._e()})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"idnumverified","label":"身份验证状态"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((_vm.options.idnumverified),function(item){return (item.value === parseInt(scope.row.idnumverified))?_c('span',[_vm._v(_vm._s(item.label))]):_vm._e()})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"wx_account","label":"微信账号"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"memo","label":"备注"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"occupation_updated_at","label":"更新时间"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","width":"160px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{staticClass:"margin b5",attrs:{"type":"danger","size":"mini","icon":"el-icon-delete"},on:{"click":function($event){return _vm.remove(scope.row.userid)}}},[_vm._v("移除\n          ")])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2),_vm._v(" "),_c('el-dialog',{attrs:{"title":"添加用户","visible":_vm.addUserDialog.visible,"width":"30%"},on:{"update:visible":function($event){return _vm.$set(_vm.addUserDialog, "visible", $event)}}},[_c('el-form',{attrs:{"model":_vm.addUserDialog,"rules":{userid: [{required: true, message: '用户不能为空', trigger: 'blur'}]},"label-width":"96px","label-position":"right","size":"medium"}},[_c('el-form-item',{attrs:{"label":"选择用户","prop":"userid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"userid","label-key":"cellphone","value-key":"userid","placeholder":"请输入用户关键字","query-request":_vm.getUserTable,"find-request":_vm.getUserDetail_},model:{value:(_vm.addUserDialog.userid),callback:function ($$v) {_vm.$set(_vm.addUserDialog, "userid", $$v)},expression:"addUserDialog.userid"}})],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.addUserDialog.visible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":!_vm.addUserDialog.userid},on:{"click":_vm.onAddUser}},[_vm._v("确 定")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/occupation-table.9d914ae815aa0330466b.js